import { GridRowId } from '@mui/x-data-grid-pro';
import { TEDFormatDate } from '../../../../../../Utils/Formatters/FormatterClasses/TEDFormatDate';
import { ParseResult } from '../../../../../../Utils/Formatters/FormatterTypes';
import {
  getFieldValidationErrorMessage,
  getFieldValidationWarningMessage,
  IFieldValidations,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';

interface IPlaneringDateValidationRow {
  id: GridRowId;
  isEmptyPlaceholder?: boolean;
  FRANDATUM?: string | null;
}

const dateFormatter = new TEDFormatDate();

const getRowFieldValidations = (
  validations: IFieldValidations | undefined,
  rowId: GridRowId,
  fieldName: string
): IFieldValidations =>
  validations?.filter(
    validation =>
      validation.fieldName === fieldName &&
      validation.path?.includes(String(rowId))
  ) ?? [];

export const getPlaneringFranDatumWarningMessage = (
  validations: IFieldValidations | undefined,
  rowId: GridRowId
): string | undefined => {
  const rowFieldValidations = getRowFieldValidations(
    validations,
    rowId,
    'FRANDATUM'
  );
  return (
    getFieldValidationErrorMessage(rowFieldValidations, 'FRANDATUM') ??
    getFieldValidationWarningMessage(rowFieldValidations, 'FRANDATUM')
  );
};

export const getInvalidFranDatumMessage = (
  value: string | null | undefined
): string | undefined => {
  if (!value) return undefined;

  return parseAndFormatFranDatum(value) === null ? 'Ogiltigt datum' : undefined;
};

const parseAndFormatFranDatum = (value: string): string | null => {
  const trimmedValue = value.trim();
  if (trimmedValue.length === 0) return '';

  const parsed = dateFormatter.parser.parse(trimmedValue);
  if (parsed.result !== ParseResult.OK) {
    return null;
  }

  return dateFormatter.displayer.display(parsed.value, true);
};

export const normalizeFranDatumInput = (value: string): string => {
  const parsed = parseAndFormatFranDatum(value);
  return parsed === null ? value.trim() : parsed;
};

export const validatePlaneringFranDatumRows = (
  currentValues: unknown
): IFieldValidations => {
  if (!Array.isArray(currentValues)) {
    return [];
  }

  return currentValues.reduce<IFieldValidations>((validations, row) => {
    const planeringRow = row as IPlaneringDateValidationRow;

    if (planeringRow.isEmptyPlaceholder || !planeringRow.FRANDATUM) {
      return validations;
    }

    const warningMessage = getInvalidFranDatumMessage(planeringRow.FRANDATUM);
    if (!warningMessage) {
      return validations;
    }

    validations.push({
      fieldName: 'FRANDATUM',
      message: warningMessage,
      type: 'Warning',
      path: [String(planeringRow.id)],
    });
    return validations;
  }, []);
};
